
(function metadataControllerDefinition() {
    'use strict';
    angular.module('Metadata')
        .controller('MetadataAddController', [
            '$scope', 'config', '$state', '$translate', 'errorsExtend', '$stateParams', 'adminMetadataService', 'authExtend', '$window', '$filter',
            function metadataController($scope, config, $state, $translate, errors, $stateParams, adminMetadataService, authExtend, $window, $filter) {
                $scope.aux = {
                    selected: {}
                };
                $scope.metadata =
                    {
                        name: '',
                        systemName: '',
                        label: '',
                        typeDataId: '',
                        maskOptionId: undefined,
                        organizationalUnitId: authExtend.getOrganizationId(),
                        organizationalUnitName: authExtend.getOrganizationName(),
                        attributes: [],
                        mask: '',
                        hasAssociatedDocument: false
                    };

                $scope.requiredOu = authExtend.getOrganizationId() ? true : false;

                $scope.aux =
                    {
                        typeData: '',
                        MaskOption: undefined
                    };

                $scope.title = 'MetadataAdd';

                adminMetadataService.getTypeDatas().then(function (result) {
                    $scope.typeDatas = $filter('filter')(result, { enabled: true });
                }, function (error) {
                    errors.showError(error);
                    $state.go('metadata-find');
                });

                $scope.createJson = function (attribute) {
                    attribute.value = '';

                    if (attribute.values && attribute.values.length > 0) {
                        var jsonArr = [];
                        for (var i = 0; attribute.values.length > i; i++) {
                            if ($scope.aux.typeData && $scope.aux.typeData.type === 'comboKV') {
                                jsonArr.push({
                                    value: attribute.values[i].value,
                                    description: attribute.values[i].description
                                });
                            } else {
                                jsonArr.push({
                                    value: attribute.values[i].value
                                });
                            }
                        }
                        attribute.value = JSON.stringify(jsonArr);
                    }
                };

                $scope.validateAtribute = function () {
                    if ($scope.metadata.attributes.length > 0) {
                        for (var i = 0; $scope.metadata.attributes.length > i; i++) {
                            if ($scope.metadata.attributes[i].type === 'optionsValues') {
                                if ($scope.metadata.attributes[i].values.length <= 0) {
                                    return false;
                                }
                                $scope.createJson($scope.metadata.attributes[i]);
                            }
                        }
                    }
                    return true;
                };

                $scope.save = function () {

                    if (!$scope.metadataForm.$valid || !$scope.validateAtribute()) {
                        $scope.metadataForm.$setSubmitted();
                        errors.showError('VerifyFormData');
                        return;
                    }

                    return adminMetadataService.create($scope.metadata).then(function (metadata) {
                        if (metadata) {
                            $state.go('metadata-find', { systemName: metadata.systemName });
                        }
                        else {
                            $state.go('metadata-find-menu');
                        }
                    }, function (error) {
                        errors.showError(error);
                    });
                };

                $scope.selectMk = function () {
                    if ($scope.aux.MaskOption) {
                        $scope.metadata.maskOptionId = $scope.aux.MaskOption.id;
                    } else {
                        $scope.metadata.maskOptionId = undefined;
                    }
                };

                $scope.selectType = function () {
                    $scope.aux.MaskOption = undefined;
                    $scope.selectMk();
                    $scope.metadata.attributes = [];
                    $scope.isOptionType = false;
                    if ($scope.aux.typeData) {
                        $scope.metadata.typeDataId = $scope.aux.typeData.id;
                        $scope.aux.typeData.typeDataAttributes.forEach(function (attribute) {                            
                            $scope.isOptionType = attribute.type === 'optionsValues';
                            $scope.metadata.attributes.push(
                                {
                                    typeDataAttributeId: attribute.id,
                                    typeDataAttributeName: attribute.name,
                                    value: '',
                                    type: attribute.type,
                                    values: []
                                });
                        });

                    } else {
                        $scope.metadata.typeDataId = '';
                    }
                };

                $scope.cancel = function () {
                    $state.go('metadata-find');
                };

                $scope.existValue = function (attribute, value) {
                    if (attribute.values && attribute.values.length > 0) {
                        for (var i = 0; attribute.values.length > i; i++) {
                            if (attribute.values[i].value === value) {
                                return true;
                            }
                        }
                    }

                    return false;
                };

                $scope.addOption = function ($event, attribute) {
                    // para que no ejecute el post al apretar enter
                    $event.stopPropagation();

                    $scope.aux.selected = {};
                    if (attribute.option && attribute.option !== '' && !$scope.existValue(attribute, attribute.option)) {
                        // solo valiudo descripcion si es un combo key value
                        if ((!$scope.aux.typeData || $scope.aux.typeData.type !== 'comboKV') || $scope.aux.typeData && $scope.aux.typeData.type === 'comboKV' && attribute.optionDescription && attribute.optionDescription !== '') {
                            attribute.values.push({ value: attribute.option, description: attribute.optionDescription, isNew: true });
                            attribute.option = '';
                            attribute.optionDescription = '';

                            var element = $window.document.getElementById("inputOptionValue");
                            if (element) {
                                element.focus();
                            }
                        }
                    }
                };

                $scope.order = function orderAsc(attribute, asc) {
                    if (!$scope.aux.typeData !== null && $scope.aux.typeData.type === 'comboKV') {
                        attribute.values = $filter('orderBy')(attribute.values, 'description', asc);
                    } else {
                        attribute.values = $filter('orderBy')(attribute.values, 'value', asc);
                    }
                };

                $scope.removeValue = function (attribute, item) {
                    if (!attribute || !attribute.values) {
                        return;
                    }

                    var indexOf = -1;
                    for (var i = 0; i < attribute.values.length; i++) {
                        if (attribute.values[i] === item) {
                            indexOf = i;
                            break;
                        }
                    }

                    if (indexOf >= 0) {
                        attribute.values.splice(indexOf, 1);
                    }
                };
            }
        ]);
})();